angular.module('tgaAdmin')
  .controller('QuestionListsModalController', [
    '$scope', '$state', '$window', '$uibModalInstance', '$uibModalStack', 'questionListService',
    'extras', '$log',
    function (
      $scope, $state, $window, $uibModalInstance, $uibModalStack, questionListService,
      extras, $log,
    ) {
      $scope.data = {
        alerts: [],
        closeButton: extras.closeButton,
        question_lists: extras.questionLists,
        gameType: extras.gameType,
      };

      $scope.viewmodel = {
        question_list_id: extras.question_list_id || null,
        showIncompatibleError: false,
      };

      $scope.actions = {
        submit() {
          if ($scope.questionListForm.$invalid) {
            return;
          }

          $scope.loading = true;

          // Prevent closing modal
          $uibModalStack.getTop().value.backdrop = 'static';
          $uibModalStack.getTop().value.keyboard = false;
          $scope.data.closeButton = false;

          questionListService.getQuestionList($scope.viewmodel.question_list_id).then((questionList) => {
            if ($scope.data.gameType === 'flash' && !questionList.question_groups.length) {
              // show incompatible message when flash and question list doesn't have categories
              $scope.viewmodel.showIncompatibleError = true;
            } else {
              $scope.viewmodel.showIncompatibleError = false;
              $uibModalInstance.close(questionList);
            }
          }).catch((error) => {
            $log.log(error);
          }).finally(() => {
            $scope.loading = false;
            $scope.data.closeButton = true;
          });
        },
        close() {
          $uibModalInstance.dismiss();
        },
      };
    },
  ]);
